export enum WallIndexEnum {
  MirrorGroup,
  VideoWallGroup
}
